import React, { useEffect, useState } from "react";
import { Box, Button, HStack, Input, Select, Text } from "@chakra-ui/react";
import {
  FILE_NAME_MATCH_OPTIONS,
  normalizeFileNameFilter,
} from "../../util/fileNameFilter";

// File Name filter bar for the Library / Archive / Videos tables (#264008).
// `value` is the applied filter ({ value, match } or undefined); `onApply`
// receives the new filter, or null to clear it.
export default function FileNameFilter({ value, onApply }) {
  const [text, setText] = useState(value?.value || "");
  const [match, setMatch] = useState(value?.match || "exact");

  // Follow the applied value when it changes elsewhere (Clear all, a restored
  // or saved filter).
  useEffect(() => {
    setText(value?.value || "");
    setMatch(value?.match || "exact");
  }, [value?.value, value?.match]);

  const applied = normalizeFileNameFilter(value);

  const handleSubmit = (e) => {
    e.preventDefault();
    onApply(normalizeFileNameFilter({ value: text, match }));
  };

  const handleClear = () => {
    setText("");
    onApply(null);
  };

  return (
    <Box
      as="form"
      onSubmit={handleSubmit}
      px={4}
      py={2}
      bg="white"
      borderBottom="1px solid"
      borderColor="gray.100"
    >
      <HStack spacing={2}>
        <Input
          size="sm"
          maxW="420px"
          aria-label="File name"
          placeholder="File name (upload sheet), e.g. 088_ARTS-Econ_July-Aug2026_v4.xlsx"
          value={text}
          maxLength={255}
          onChange={(e) => setText(e.target.value)}
        />
        <Select
          size="sm"
          maxW="140px"
          aria-label="File name match"
          value={match}
          onChange={(e) => setMatch(e.target.value)}
        >
          {FILE_NAME_MATCH_OPTIONS.map((opt) => (
            <option key={opt.value} value={opt.value}>
              {opt.label}
            </option>
          ))}
        </Select>
        <Button size="sm" type="submit" isDisabled={!text.trim()}>
          Apply
        </Button>
        {applied && (
          <Button size="sm" variant="ghost" onClick={handleClear}>
            Clear file name
          </Button>
        )}
      </HStack>
      {applied && (
        <Text fontSize="sm" color="gray.600" pt={1}>
          {`Showing records whose file name ${
            applied.match === "prefix" ? "starts with" : "is"
          } "${applied.value}". Search and other filters are not applied while a file name is set; Export uses the same records.`}
        </Text>
      )}
    </Box>
  );
}
